import { PartialBusinessEntityOptions } from '../../../lib/libby';

export const businessOptions: { [k: string]: PartialBusinessEntityOptions<any> } = {};
